<template>
  <div class="lds-default">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</template>
<script>
export default {
  name: "Loading",
};
</script>
<style scoped>
.lds-default {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
  display: flex;
  margin: auto;
}
.lds-default div {
  position: absolute;
  width: 4px;
  height: 4px;
  background: #008fc1;
  border-radius: 50%;
  animation: lds-default 1.2s linear infinite;
}
.lds-default div:nth-child(1) {
  animation-delay: 0s;
  top: 1px;
  left: 8px;
}
.lds-default div:nth-child(2) {
  animation-delay: -0.1s;
  top: 3px;
  left: 13px;
}
.lds-default div:nth-child(3) {
  animation-delay: -0.2s;
  top: 8px;
  right: 1px;
}
.lds-default div:nth-child(4) {
  animation-delay: -0.3s;
  top: 13px;
  left: 13px;
}
.lds-default div:nth-child(5) {
  animation-delay: -0.4s;
  bottom: 1px;
  left: 8px;
}
.lds-default div:nth-child(6) {
  animation-delay: -0.5s;
  top: 13px;
  right: 13px;
}
.lds-default div:nth-child(7) {
  animation-delay: -0.6s;
  top: 8px;
  left: 1px;
}
.lds-default div:nth-child(8) {
  animation-delay: -0.7s;
  top: 3px;
  right: 13px;
}
@keyframes lds-default {
  0%,
  20%,
  80%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
}
</style>
